/*
 * PROD-7828 — month=YYYY-MM in the URL on every Teacher Payments page, so a link can be shared or
 * refreshed without losing the selected month (Kuldeep 2026-10-01). Pure; the shell (index.jsx) reads
 * and writes it, and the per-tab filter writers merge it in rather than overwriting the whole search.
 *
 * Kept in 'YYYY-MM', the shell's own pay_month form (overview_months.json, close_versions, penalties
 * all key their month lists this way) — NOT 'YYYY-MM-01'. A few endpoints want '-01' at their own call
 * site (additional_payments' api_pay_month, email_logs), but that conversion already happens there;
 * doing it here too would make month_from_search's value never match the months list's own 'YYYY-MM'
 * entries in accept_month_choice/pick_initial_month, silently breaking every deep link.
 */
const MONTH_RE = /^\d{4}-(0[1-9]|1[0-2])$/;

// 'month=' first; a legacy 'pay_month=' deep link (the overview/needs_attention Slack digest links,
// and close_versions' own view-state param) still works.
export const month_from_search = (search) => {
  const qs = new URLSearchParams(typeof search === 'string' ? search : '');
  const month = (qs.get('month') || '').trim();
  if (MONTH_RE.test(month)) return month;
  const legacy = (qs.get('pay_month') || '').trim();
  return MONTH_RE.test(legacy) ? legacy : '';
};

// Merges 'month' into the existing search, keeping every other param untouched; '' removes it.
export const with_month = (search, pay_month) => {
  const qs = new URLSearchParams(typeof search === 'string' ? search : '');
  if (pay_month) qs.set('month', pay_month);
  else qs.delete('month');
  return qs.toString();
};
